import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { VOIVODESHIPS } from "@/constants/voivodeships";
import { FieldSelect, type FieldSelectProps } from "./FieldSelect";

export const VoivodeshipSelect: FC<Omit<FieldSelectProps, "values">> = ({
  onChange,
  className,
  value,
  isError,
  disabled,
  dataTest,
}) => {
  const { t } = useTranslation();

  return (
    <FieldSelect
      isError={isError}
      disabled={disabled}
      values={VOIVODESHIPS.map(v => ({ value: v, label: t(`voivodeships.${v}`) }))}
      value={value}
      onChange={onChange}
      className={className}
      dataTest={dataTest}
    />
  );
};
